import styled from '@emotion/styled';
import Button from '@mui/material/Button';
import ButtonGroup from '@mui/material/ButtonGroup';
import { MixinTruncate, TextSize90 } from '@shared/components/core/text/Typography';

export const SplitButtonGroup = styled(ButtonGroup)`
    margin: 0.5rem 0 0 0;
    background-color: ${(props) => props.theme.button.secondary.background};
    color: ${(props) => props.theme.button.secondary.text};
`;

export const SplitPrimaryButton = styled(Button)`
    ${TextSize90}
    text-transform: none;
    background-color: ${(props) => props.theme.button.secondary.background};
    color: ${(props) => props.theme.button.secondary.text};
    &:hover {
        background-color: ${(props) => props.theme.button.accent.hoverBackground};
        color: ${(props) => props.theme.button.accent.hoverText};
    }
`;

export const SplitSecondaryButton = styled(Button)`
    max-width: fit-content;
    background-color: ${(props) => props.theme.button.secondary.background};
    color: ${(props) => props.theme.button.secondary.text};
    &:hover {
        background-color: ${(props) => props.theme.button.accent.hoverBackground};
        color: ${(props) => props.theme.button.accent.hoverText};
    }
`;

export const SplitTruncatedLabel = styled.span`
    ${MixinTruncate}
`;
